<template>
  <div class="dialog" :class="{ active: dialog }">
    <div class="dialog-content md no-line">
      <div class="dialog-content-header bg-default pa-2">
        <div class="flex-grow-1 text-uppercase font-weight-600 text-color-light">Valor do negócio</div>
      </div>
      <span class="divider"></span>
      <div class="dialog-content-body">
        <div class="pa-2 bg-contrast">
          <b-textfield placeholder="Motivo da alteração" class="mb-0" :multiline="true" />
        </div>
      </div>
      <span class="divider"></span>
      <div class="dialog-content-footer justify-end">
        <button class="btn outlined sm" @click="close()">Limpar</button>
        <button class="btn btn-coral sm" @click="close()">Aplicar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
      this.$emit('closeContact')
    }
  }
}
</script>
